{
  "bell.title": "Aviseringar",
  "bell.open": "Visa aviseringar",
  "bell.unread.one": "{count} oläst",
  "bell.unread.other": "{count} olästa",
  "bell.awaiting.one": "{count} väntar på svar",
  "bell.awaiting.other": "{count} väntar på svar",
  "bell.empty": "Inget nytt just nu.",
  "bell.empty_hint": "Nya bokningar, ombokningar och avbokningar dyker upp här.",
  "bell.mark_all_read": "Markera alla som lästa",
  "bell.settings": "Inställningar för aviseringar",
  "bell.error": "Aviseringarna kunde inte hämtas.",
  "bell.confirm": "Bekräfta",
  "bell.reject": "Avvisa",
  "bell.reject_reason": "Avvisad av verkstaden",
  "bell.handled": "Redan hanterad",
  "bell.unknown_customer": "Kund utan namn",
  "bell.unknown_service": "Tjänst",
  "bell.kind.booking_requested": "Ny bokning att bekräfta",
  "bell.kind.booking_created": "Ny bokning",
  "bell.kind.booking_rescheduled": "Kunden har bokat om",
  "bell.kind.booking_cancelled": "Kunden har avbokat",
  "bell.kind.email_failed": "Mejlet kom inte fram",
  "bell.body.booking_requested": "{customer} vill boka {service} {when}. Bekräfta eller avvisa.",
  "bell.body.booking_created": "{customer} har bokat {service} {when}.",
  "bell.body.booking_rescheduled": "{customer} har flyttat {service} till {when}.",
  "bell.body.booking_cancelled": "{customer} har avbokat {service} {when}.",
  "bell.body.email_failed": "Ett mejl studsade. Kunden vet inte om sin bokning — ring dem.",
  "settings.nav.notifications": "Aviseringar",
  "settings.notifications.heading": "Dina aviseringar",
  "settings.notifications.body": "Det här gäller dig, inte verkstaden. Ändrar du här ändras inget för dina kollegor.",
  "settings.notifications.sound": "Spela ett ljud",
  "settings.notifications.sound_hint": "En kort signal när något nytt dyker upp. Bra på en surfplatta i disken.",
  "settings.notifications.test_sound": "Testa ljudet",
  "settings.notifications.desktop": "Visa en avisering i datorn",
  "settings.notifications.desktop_hint": "Syns även när fliken ligger i bakgrunden. Webbläsaren frågar om lov först.",
  "settings.notifications.desktop_blocked": "Webbläsaren har blockerat aviseringar. Släpp fram dem i webbläsarens egna inställningar.",
  "settings.notifications.kinds": "Vad vill du höra om?",
  "settings.notifications.kinds_hint": "Avbockade händelser hamnar fortfarande i klockan, men utan ljud.",
  "settings.notifications.sound_blocked": "Webbläsaren lät inte ljudet spelas. Klicka någonstans på sidan och försök igen.",
  "notifications.all_caught_up": "Allt är läst. Inget väntar på svar.",
  "notifications.filter.all": "Allt",
  "notifications.filter.unread_only": "Bara olästa",
  "notifications.load_more": "Visa fler",
  "notifications.empty_filtered": "Inget matchar filtret.",
  "notifications.empty_filtered_hint": "Prova ett annat urval, eller välj Allt för att se hela listan.",
  "notifications.to_calendar": "Till kalendern",
  "notifications.messaging.test_message": "ColorGlo: testmeddelande från sidan Integrationer.",
  "notifications.sms.booking_confirmed": "Din tid hos {workshop_name} är bokad: {date} kl. {time}, {location}. Bokningsnummer {reference}. Ändra eller avboka: {manage_link}",
  "notifications.sms.reminder": "Påminnelse: du har en tid hos {workshop_name} {date} kl. {time}, {location}. Ändra eller avboka: {manage_link}",
  "notifications.sms.rescheduled": "Din tid hos {workshop_name} är flyttad till {date} kl. {time}. Se bokningen: {manage_link}",
  "notifications.sms.cancelled": "Din tid hos {workshop_name} {date} kl. {time} är avbokad. Välkommen att boka en ny tid.",
  "bell.kind.shop_order_approved": "Beställning godkänd",
  "bell.kind.shop_order_rejected": "Beställning avvisad",
  "bell.kind.shop_order_shipped": "Beställning skickad",
  "bell.body.shop_order_approved": "HQ har godkänt order {number}.",
  "bell.body.shop_order_rejected": "HQ har avvisat order {number}.",
  "bell.body.shop_order_shipped": "Order {number} är skickad. Följesedeln finns på ordern.",
  "bell.kind.shop_order_cancelled": "Beställning avbruten av HQ",
  "bell.body.shop_order_cancelled": "HQ har avbrutit order {number}."
}
